<template>
  <div :class="{ 'disabled' : saving || fetching }" class="clickable add-item" @click="addRowOrToggleOptions()">
    <b-button :disabled="saving || fetching" class="clickable" variant="link" style="padding:0">
      <i class="fas fa-plus"></i>
      <span v-if="!parentId">Row</span>
    </b-button>

    <div v-if="showBtns" class="add-buttons">

      <b-button class="badge badge-secondary clickable" @click="addItem('paragraph')">
        <i class="fas fa-align-left"></i>
        <span>Paragraph</span>
      </b-button>

      <b-button class="badge badge-secondary clickable" @click="addItem('video')">
        <i class="fas fa-play "></i>
        <span>Video</span>
      </b-button>

      <b-button class="badge badge-secondary clickable" @click="addItem('image')">
        <i class="fas fa-images"></i>
        <span>Image</span>
      </b-button>

      <b-button class="badge badge-secondary clickable" @click="addItem('pdf')">
        <i class="fas fa-file-pdf "></i>
        <span>PDF</span>
      </b-button>

      <b-button class="badge badge-secondary clickable" @click="addItem('audio')">
        <i class="fas fa-volume-up"></i>
        <span>Audio</span>
      </b-button>
    </div>
    <div class="add-line"></div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    level: {
      type: Number,
      default: 0
    },
    nextId: {
      type: String,
      required: false,
      default: ''
    },
    parentId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      showBtns: false
    }
  },
  computed: {
    ...mapState('items', [
      'saving',
      'fetching'
    ])
  },
  methods: {
    addRowOrToggleOptions() {
      if (this.saving || this.fetching) {
        return
      }
      if (this.parentId) { // show options
        this.showBtns = !this.showBtns
      } else { // add row
        this.addItem('row')
      }
    },
    addItem(type) {
      this.$store.commit('items/addItem', {
        nextID: this.nextId.length ? this.nextId : null,
        parentID: this.parentId.length ? this.parentId : null,
        type
      })
    }
  }
}
</script>

<style lang="scss">

.add-item {
  grid-column: span 3;
  display: flex;
  align-items: center;
  min-height: 1.2rem;
  margin: 20px 0;
  opacity: .5;
  height: 1.25rem;
  transition: opacity .3s ease-in-out;

  button:hover {
    text-decoration: none;
  }

  &.disabled {
    cursor: not-allowed !important;

    &:hover {
      opacity: .5;
    }

    button {
      cursor: not-allowed;
    }
  }

  .add-buttons {
    margin-left: 20px;
    line-height: 0;
  }

  .add-line {
    flex: 1;
    height: 1px;
    margin-left: 20px;
    background-color: #ccc;
  }

  .badge { cursor: pointer; }

  &:hover { opacity: 1; }

}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/items/add.vue